/** Linked staff order identity; never substitute the invoice ID or internal UUID. */
export function orderReference(shipmentId?: number | null) {
  return Number.isSafeInteger(shipmentId) && shipmentId! > 0
    ? `Order #${shipmentId}`
    : 'Order reference unavailable';
}
